import axios from "axios";
import { Column_URL, User_Service_URL, Partner_Service_URL } from "../Url";
// import HashMap from "hashmap";

export const CommonListActions = {
  COMMON_LIST: "COMMON_LIST",
  COMMON_LIST_SUCCESS: "COMMON_LIST_SUCCESS",
  COMMON_LIST_ERROR: "COMMON_LIST_ERROR",
  LOGOUT: "LOGOUT",
  UPDATE_TAB: "UPDATE_TAB",
};

export const DynamicTabsActions = {
  DYNAMIC_TABS: "DYNAMIC_TABS",
  DYNAMIC_TABS_SUCCESS: "DYNAMIC_TABS_SUCCESS",
  DYNAMIC_TABS_ERROR: "DYNAMIC_TABS_ERROR",
};
export const TabStatusCountActions = {
  TAB_STATUS_COUNT_SUCCESS: "TAB_STATUS_COUNT_SUCCESS",
};
export const columnsListActions = {
  COLUMN_LIST_SUCCESS: "COLUMN_LIST_SUCCESS",
  COLUMN_LIST_ERROR: "COLUMN_LIST_ERROR",
};

export const TabsActionButtonsActions = {
  TABS_ACTION_BUTTONS_SUCCESS: "TABS_ACTION_BUTTONS_SUCCESS",
  TABS_ACTION_BUTTONS_ERROR: "TABS_ACTION_BUTTONS_ERROR",
};

export function getTabStatusCount(props) {
  const { access_token, params } = props;
  return (dispatch, getState) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/getTabCaseCountByLoggedInRoleTypeForUserMaster`,
      params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          let tabs =
            response.data?.tabCaseCount?.map((item) => item.tabName) ?? [];

          dispatch(getTabStatusCountSuccess(tabs));
          return response.data;
        } else {
          const error = new Error(response.error);
          dispatch(getCommonListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getCommonListError(err));
          return err.response;
        }
      });
}

export function getDynamicTabs(props) {
  const { access_token } = props;
  return (dispatch, getState) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/getTabCaseCountByLoggedInRoleTypeForUserMaster`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getDynamicTabsSuccess(response.data.Tabs));
          return response.data;
        } else {
          const error = new Error(response.error);
          dispatch(getCommonListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getCommonListError(err));
          return err.response;
        }
      });
}
export function getCommonListing(props) {
  const {
    access_token,
    sortField,
    sortOrder,
    searchData,
    tab,
    pageIndex,
    pageSize,
    params,
  } = props;

  const search = [];

  let listing_Dto = {
    addtionalSearch: [],
    columnNames: [],
    defaultSort: {
      sortField: `userId`,
      sortOrder: `desc`,
    },
    isRegistered: true,
    length: pageSize ?? 10,
    requestType: 0,
    search: searchData || search,
    sequenceColumnDTOs: [
      {
        columnID: 0,
        sequenceColumn: 0,
      },
    ],
    sort: [
      {
        sortField: `userId`,
        sortOrder: `desc`,
      },
    ],
    start: pageIndex ?? 0,
    status: true,
    statusCode: 0,
  };

  return (dispatch, getState) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/listingPartnerUser`,
      data: listing_Dto,
      params: {
        tab: tab ? tab : "ACTIVE",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(
            getCommonListSuccess(
              response?.data?.userFieldsDto?.fields,
              tab ?? "ACTIVE"
            )
          );
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getCommonListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getCommonListError(err));
          return err.response;
        }
      });
}

export function updateTab(tab) {
  return {
    type: CommonListActions.UPDATE_TAB,
    payload: tab,
  };
}

export function getCommonListRequest() {
  return {
    type: CommonListActions.COMMON_LIST,
    isPosting: true,
  };
}
export function getCommonListError(error) {
  return {
    type: CommonListActions.COMMON_LIST_ERROR,
    payload: error,
  };
}

export function getCommonListSuccess(fields, tab) {
  return (dispatch) => {
    dispatch({
      type: CommonListActions.COMMON_LIST_SUCCESS,
      payload: { fields, tab },
    });
  };
}

export function getDynamicTabsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: DynamicTabsActions.DYNAMIC_TABS_SUCCESS,
      payload: props,
    });
  };
}
export function getDynamicTabsError(props) {
  return (dispatch) => {
    dispatch({
      type: DynamicTabsActions.DYNAMIC_TABS_ERROR,
      payload: props,
    });
  };
}
export function getTabStatusCountSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: "TAB_STATUS_COUNT_SUCCESS",
      payload: props,
    });
  };
}
export function getColumnsMaster(props) {
  const { access_token } = props;
  let values = {};
  return (dispatch, getState) =>
    axios({
      method: "post",
      url: `${Column_URL}/get/fieldsList?listingMaster=PARTNER_FIRM_LISTING`,
      data: values,
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(columnsListSuccess(values));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(columnsListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(columnsListError(err));
          return err.response;
        }
      });
}

export function columnsListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: columnsListActions.COLUMN_LIST_SUCCESS,
      payload: props,
    });
  };
}

export function columnsListError(error) {
  return {
    type: columnsListActions.COLUMN_LIST_ERROR,
    payload: error,
  };
}

export function updateColumnsMaster(props) {
  const { access_token, userFields } = props;
  return (dispatch, getState) =>
    axios({
      method: "post",
      data: userFields,
      url: `${Column_URL}/update/fields/ByLoggedInUser`,
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response.data;
        } else if (response.status >= 401 && response.status < 500) {
          return response;
        } else {
          // dispatch(clearLogoutData());
          const error = new Error(response.statusText);
          return error;
        }
      })
      .catch((err) => {
        //
        if (err.response) {
          // map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          // map.forEach((ele) => (err = ele));
          return err;
        } else {
          // dispatch(clearLogoutData());
        }
      });
}

export function TabsActionButtonsList(props) {
  const { access_token } = props;

  return (dispatch, getState) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getActionButtonPartnerUserRole`,

      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(TabsActionButtonsListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(TabsActionButtonsListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(TabsActionButtonsListError(err));
          return err.response;
        }
      });
}

export function TabsActionButtonsListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TabsActionButtonsActions.TABS_ACTION_BUTTONS_SUCCESS,
      payload: props,
    });
  };
}

export function TabsActionButtonsListError(error) {
  return {
    type: TabsActionButtonsActions.TABS_ACTION_BUTTONS_ERROR,
    payload: error,
  };
}
